import { useEffect } from 'preact/hooks'
import { WebLeadsPanel } from '../WebLeadsPanel'
import { routes } from '@/utils/routes'
import { useAIChatContextUpdater } from '@/hooks'
import { ChatLocations, ChatEntityTypes, ChatViewModes } from '@/constants/aiChat'
import type { WebViewDto } from '@/api/webs'

interface Props {
  clientCompanyId: string
  workspaceId: string
  campaignId: string
  web: WebViewDto
}

// Leads tab now embeds the full WebLeadsPanel. Deep-linking (/leads, /leads/companies) works because
// the panel derives its internal mode from the current URL path.
export function WebLeadsTab({ clientCompanyId, workspaceId, campaignId, web }: Props) {
  const r = routes.scoped(clientCompanyId, workspaceId)
  const { updateContext } = useAIChatContextUpdater()

  useEffect(() => {
    updateContext({
      campaignId,
      webId: web.Id,
      location: ChatLocations.WebLeads,
      entityType: ChatEntityTypes.Web,
      entityId: web.Id,
      viewMode: ChatViewModes.View,
      availableFields: [],
      availableActions: ['CopyToClipboard'],
    })
  }, [workspaceId, campaignId, web.Id, updateContext])

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-sm">
      <WebLeadsPanel
        clientCompanyId={clientCompanyId}
        workspaceId={workspaceId}
        campaignId={campaignId}
        webId={web.Id}
        baseWebPath={r.web(campaignId, web.Id)}
        web={{ Id: web.Id, Name: web.Name, WebType: web.Type }}
      />
    </div>
  )
}
